import React, { FC } from 'react'
import cn from 'classnames'

interface DatePlaceholderProps {
  placeholder: string
  date?: string
  truncate?: boolean
  displaySeparator?: boolean
}

export const DatePlaceholder: FC<DatePlaceholderProps> = ({ date, placeholder, truncate, displaySeparator }) => (
  <p
    className={cn('max-w-36 cursor-pointer whitespace-nowrap', {
      'text-neutral-medium-light xs:max-w-48 sm:max-w-72': !date,
      'xxs:max-w-44 truncate lg:max-w-36': truncate,
    })}
  >
    {`${displaySeparator ? '-' : ''} ${date || placeholder}`}
  </p>
)
